

































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import Course from '../../../api/v2/models/course'
import Tag from '../../../api/v2/models/course_tag'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'
import MenuTab from '../atoms_molecules/MenuTab.vue'

@Component({
  components: {
    MenuTab
  }
})
export default class CourseList extends Vue {
  courses: Course[] = []
  tags: Tag[] = [] 
  mobile = checkMobile()
  drawerRight = !this.mobile
  search = ''
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'コース一覧',
      disabled: false,
      exact: true,
      to: '/classroom/courses'
    }
  ]

  async created() {
    if (this.$route.path.indexOf('/courses') !== -1) {
      headerState.setTitle('コース一覧')
    }
    const listId = this.$route.query['tag'] as string
    this.courses = await api.course.index({tagId: listId}).catch()
    this.tags = await api.courseTag.index()
  }
  
  @Watch('search')
  async watchSearch(){
    const listId = this.$route.query['tag'] as string
    this.courses = await api.course.index({tagId: listId, search: this.search}).catch()
  }
  resetTag() {
    this.$router.push({ query: {} })
  }

  setTag(id) {
    this.$router.push({ query: {tag: id} })
  }

  @Watch('$route', { immediate: true })
  async onChangeQueryRoute() {
    const listId = this.$route.query['tag'] as string
    this.courses = await api.course.index({tagId: listId})
  }
}
